import { motion } from "framer-motion";
import {
  Factory, HeartPulse, Pill, ShoppingBag, Network, Warehouse, Plane, Truck,
  Landmark, Banknote, Briefcase, Home,
} from "lucide-react";
import { INDUSTRY_IMAGES } from "@/lib/media";

const INDUSTRIES = [
  { icon: Factory, t: "Manufacturing" },
  { icon: HeartPulse, t: "Healthcare" },
  { icon: Pill, t: "Pharmaceuticals" },
  { icon: ShoppingBag, t: "Retail" },
  { icon: Network, t: "Distribution" },
  { icon: Warehouse, t: "Warehousing" },
  { icon: Plane, t: "Transportation" },
  { icon: Truck, t: "Logistics" },
  { icon: Landmark, t: "Government" },
  { icon: Banknote, t: "Financial Services" },
  { icon: Briefcase, t: "Professional Services" },
  { icon: Home, t: "Real Estate" },
];

export default function Industries() {
  return (
    <section id="industries" className="bg-[#F8FAFC] border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="section-eyebrow mb-5">Industries We Serve</div>
          <h2 className="font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#0A2540] leading-tight">
            Domain depth across twelve sectors
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
          {INDUSTRIES.map((ind, i) => (
            <motion.div
              key={ind.t}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: (i % 4) * 0.04 }}
              className="relative bg-[#0A2540] aspect-[4/3] overflow-hidden group cursor-default"
            >
              <img
                src={INDUSTRY_IMAGES[ind.t]}
                alt={ind.t}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A2540] via-[#0A2540]/60 to-[#0A2540]/20" />
              <div className="absolute inset-0 flex flex-col items-start justify-end p-5 text-white">
                <ind.icon size={22} className="text-[#10B981] mb-2" />
                <h3 className="font-display font-semibold text-base leading-tight">{ind.t}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
